import { ZIGBEE_COORDINATOR_STATUS } from '../commissioning/commissioning.model';

export const COMMISSIONING_STATUSES: {
  [key: string]: { messageKey: string; type: 'info' | 'error' | 'success' };
} = {
  [ZIGBEE_COORDINATOR_STATUS.DISABLED]: {
    messageKey: '+COMMISSIONING.STATUS.DISABLED',
    type: 'error',
  },
  [ZIGBEE_COORDINATOR_STATUS.OK]: {
    messageKey: '+COMMISSIONING.STATUS.OK',
    type: 'success',
  },
  [ZIGBEE_COORDINATOR_STATUS.LEARNING]: {
    messageKey: '+COMMISSIONING.STATUS.LEARNING',
    type: 'info',
  },
  [ZIGBEE_COORDINATOR_STATUS.TIMEOUT]: {
    messageKey: '+COMMISSIONING.STATUS.TIMEOUT',
    type: 'error',
  },
  [ZIGBEE_COORDINATOR_STATUS.LEARNING_FAILED]: {
    messageKey: '+COMMISSIONING.STATUS.LEARNING_FAILED',
    type: 'error',
  },
  [ZIGBEE_COORDINATOR_STATUS.INVALID_FORMAT]: {
    messageKey: '+COMMISSIONING.STATUS.INVALID_FORMAT',
    type: 'error',
  },
  [ZIGBEE_COORDINATOR_STATUS.ZIGBEE_ERROR]: {
    messageKey: '+COMMISSIONING.STATUS.ZIGBEE_ERROR',
    type: 'error',
  },
  [ZIGBEE_COORDINATOR_STATUS.ALREADY_PAIRED]: {
    messageKey: '+COMMISSIONING.STATUS.ALREADY_PAIRED',
    type: 'error',
  },
  [ZIGBEE_COORDINATOR_STATUS.INITIATING]: {
    messageKey: '+COMMISSIONING.STATUS.INITIATING',
    type: 'info',
  },
  [ZIGBEE_COORDINATOR_STATUS.CONNECTING]: {
    messageKey: '+COMMISSIONING.STATUS.INITIATING',
    type: 'info',
  },
  [ZIGBEE_COORDINATOR_STATUS.UNKNOWN]: {
    messageKey: '+COMMISSIONING.STATUS.UNKNOWN',
    type: 'error',
  },
};
